import React from 'react';

const UserIcon = () => {
  return (
    <svg
      width='20'
      height='20'
      viewBox='0 0 20 20'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
    >
      <path
        d='M9.99967 9.99999C12.3009 9.99999 14.1663 8.13451 14.1663 5.83332C14.1663 3.53214 12.3009 1.66666 9.99967 1.66666C7.69849 1.66666 5.83301 3.53214 5.83301 5.83332C5.83301 8.13451 7.69849 9.99999 9.99967 9.99999Z'
        fill='#333333'
      />
      <path
        d='M9.9998 12.0833C5.8248 12.0833 2.4248 14.8833 2.4248 18.3333C2.4248 18.5667 2.60814 18.75 2.84147 18.75H17.1581C17.3915 18.75 17.5748 18.5667 17.5748 18.3333C17.5748 14.8833 14.1748 12.0833 9.9998 12.0833Z'
        fill='#333333'
      />
    </svg>
  );
};

export default UserIcon;
